import {Component, Input} from '@angular/core';

import {TranslateDirective} from "../../directives/translate.directive";

@Component({
    selector: 'app-headline',
    imports: [
        TranslateDirective
    ],
    templateUrl: './headline.component.html',
    styleUrl: './headline.component.scss'
})
export class HeadlineComponent {

  @Input() public type: 'h4' | 'h5' | 'h6' = 'h5';
  @Input() public title: string = '';
  @Input() public class: string = '';
}
